export enum SingleCabinFormCapacityType {
    DYNAMIC = 'Dynamic',
    FIXED = 'Fixed'
  }
  